var breakpoints = {
  xs: '320px',
  sm: '544px',
  md: '767px',
  lg: '1025px',
  xl: '1272px'
};

export { breakpoints as default };
